export default __webpack_public_path__ + "static/media/epica-mobile-2.600f2b01.png";